export const Nice: React.FC<{ className?: string; isActive: boolean }> = ({ className, isActive }) =>
  isActive ? (
    <svg viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <circle cx="36" cy="36" r="34" fill="#EDEDFD" stroke="#4B4DED" strokeWidth="4" />
      <path
        d="M36.2002 56.2002C47.2459 56.2002 56.2002 47.2459 56.2002 36.2002C56.2002 25.1545 47.2459 16.2002 36.2002 16.2002C25.1545 16.2002 16.2002 25.1545 16.2002 36.2002C16.2002 47.2459 25.1545 56.2002 36.2002 56.2002Z"
        stroke="#262641"
        strokeWidth="4.008"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.2002 40.2002C28.2002 40.2002 31.2002 44.2002 36.2002 44.2002C41.2002 44.2002 44.2002 40.2002 44.2002 40.2002"
        stroke="#4B4DED"
        strokeWidth="4.008"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M30.2002 30.2002H30.2202" stroke="#4B4DED" strokeWidth="4.008" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M42.2002 30.2002H42.2202" stroke="#4B4DED" strokeWidth="4.008" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ) : (
    <svg className={className} viewBox="0 0 66 66" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="33" cy="33" r="31.5" fill="#F2F2F4" stroke="#C3C3CB" stroke-width="3" />
      <path
        d="M33.2002 53.2002C44.2459 53.2002 53.2002 44.2459 53.2002 33.2002C53.2002 22.1545 44.2459 13.2002 33.2002 13.2002C22.1545 13.2002 13.2002 22.1545 13.2002 33.2002C13.2002 44.2459 22.1545 53.2002 33.2002 53.2002Z"
        stroke="#C3C3CB"
        stroke-width="4.008"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M25.2002 37.2002C25.2002 37.2002 28.2002 41.2002 33.2002 41.2002C38.2002 41.2002 41.2002 37.2002 41.2002 37.2002"
        stroke="#C3C3CB"
        stroke-width="4.008"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M27.2002 27.2002H27.2202" stroke="#C3C3CB" stroke-width="4.008" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M39.2002 27.2002H39.2202" stroke="#C3C3CB" stroke-width="4.008" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
